import React from 'react';
import { Component } from 'react';
import carData from '../../data/carSelectionData';
import Constants from '../../data/constants';
import carImages from '../../data/carImages';

class CarSelectionBlock extends Component {
    constructor(props) {
        super(props);


        this.elems = {};
        this.state = {
            model: this.getDefaultState(true),
            selState: {width: (1 / carData.model.length * 100) + '%'}
        }
    }

    componentDidMount() {
        const { offsetWidth, offsetHeight, offsetLeft, offsetTop } = this.elems.ModelS;

        this.setState(
            {
                selState: {
                    width: offsetWidth + 'px',
                    height: offsetHeight + 'px',
                    left: offsetLeft + 'px',
                    top: offsetTop + 'px'
                }
            }
        );
    }

    getDefaultState(firstLoad) {
        const { MODEL_S, MODEL_X, MODEL_3, MODEL_Y } = Constants();

        return {
                [MODEL_S + "Active"]: firstLoad,
                [MODEL_X + "Active"]: false,
                [MODEL_3 + "Active"]: false,
                [MODEL_Y + "Active"]: false
            };
    }

    setModel(val) {
        this._model = val;
    }

    getModel() {
        return this._model;
    }

    handleModelSelect(model, e) {
        let newState = this.getDefaultState(false),
            currEl = e.target,
            selection = e.target.getAttribute('data-model');

        newState[selection + 'Active'] = true;
        this.props.setModel(selection);

        this.setState(
            {
                model: newState,
                selState: {
                    width: currEl.clientWidth + 6 + 'px',
                    height: currEl.clientHeight + 6 + 'px',
                    left: currEl.offsetLeft + 'px',
                    top: currEl.offsetTop + 'px'
                }
            }
        );
    }

    render() {
        let { state } = this,
            { selState } = this.state,
            { model, name } = carData;

        let models = model[(typeof window.Tesla !== "undefined" ? window.Tesla.country.toUpperCase() : "US")];
        if (typeof models === "undefined") {
            models = model.defaultModels;
        }

        return (
            <div>
                <div className={'car-selection'} onClick={this.handleModelSelect.bind(this, model)}>
                    {models.map( (m, i) => {
                        let activeClass = state.model[m + 'Active'];
                        return (
                            <div key={i} className={'car-model model-' + m.toLowerCase()} style={{backgroundImage: `url(${Constants().RESOURCE_BASE_URL}${carImages[m.toLowerCase()]})`}} data-model={m} ref={ input => {this.elems[m] = input}}>
                                <span className={'model-name' + (activeClass ? ' active' : '')}>{name[m]}</span>
                            </div>
                        )
                    })}
                    <div className='car-selector' style={selState}></div>
                </div>
            </div>
        )
    }
}

export default CarSelectionBlock
